import {render, h} from "./_snowpack/pkg/preact.js";
import {useState, useEffect} from "./_snowpack/pkg/preact/hooks.js";
import {graphql, useQuery} from "./picoql.js";
import ActivityIndicator from "./components/ActivityIndicator.js";
import ErrorBoundary from "./components/ErrorBoundary.js";
import BigInput from "./components/search/BigInput.js";
import SearchResult from "./components/search/SearchResult.js";
import useSearch from "./components/search/useSearch.js";
function Search() {
  const [search, searchDebounced, setSearch] = useSearch();
  const {data, loading, refetch} = useQuery(graphql`
    query SearchQuery($query: String!) {
      search(query: $query) {
        id
        results(first: 20) {
          edges {
            node {
              id
              url
              title
              slug
              upvoteCount
            }
          }
        }
      }
    }
  `, {query: searchDebounced});
  useEffect(() => refetch({query: searchDebounced}), [searchDebounced]);
  const hasResults = data?.search?.results?.edges?.length > 0;
  return /* @__PURE__ */ h("div", {
    class: "w-full flex flex-col items-center"
  }, /* @__PURE__ */ h(BigInput, {
    placeholder: "Search ...",
    value: search,
    onChange: setSearch,
    loading,
    style: "mb-2"
  }), hasResults ? data.search.results.edges.map(({node}) => {
    return /* @__PURE__ */ h(SearchResult, {
      ...node
    });
  }) : /* @__PURE__ */ h("h3", {
    class: "text-gray-500 my-4"
  }, "No matching results found"));
}
render(/* @__PURE__ */ h(ErrorBoundary, null, /* @__PURE__ */ h(Search, null)), document.getElementById("search"));
